import React from 'react'
import { Typography } from '@material-ui/core'
import { ModalConfirmacao } from 'components'

export const ModalPassagemVestigio = (props) => {
  const { aberto, onClose, onConfirm, processando, operacao } = props

  const getTitulo = () => {
    switch (operacao) {
      case 'NEGAR':
        return 'Negar passagem de custódia'
      case 'ACEITAR':
        return 'Aceitar passagem de custódia'
      case 'CANCELAR':
        return 'Cancelar passagem de custódia'
      default:
        return ''
    }
  }

  return (
    <ModalConfirmacao
      aberto={aberto}
      onClose={onClose}
      onConfirm={onConfirm}
      processando={processando}
      titulo={getTitulo().toUpperCase()}
      confirmarLabel="Confirmar"
      maxWidth="sm"
    >
      <Typography variant="body1" style={{ marginTop: '10px' }}>
        Tem certeza que deseja realizar essa operação?
      </Typography>
    </ModalConfirmacao>
  )
}
